<card-form #cardForm
           [options]="cardOptions"
           (onSubmit)="onSubmit()">
    <div class="card-header-content">
        <h1>{{ templateLabels.bookingSearch }}</h1>

        <btnForm styleType="actionHeaderLink"
                 (click)="onReset()">
            {{ templateLabels.newSearch }}
        </btnForm>
    </div>
    <div class="card-body-content card-padding-inside">
        <div class="col-to-row-s-mb">
            <div class="flex-1 spacing-bottom">
                <chips class="e2e-chips-search-booking" #textField
                       [toUpper]="chipsToUpper"
                       [fieldConfig]="formFields.text">
                    <field-description [description]="fieldDescriptionLabels.text"></field-description>
                </chips>
            </div>
        </div>
        <div class="col-to-row-s-mb sep-top">
            <div class="flex-1 sep-right">
                <booking-fieldset #bookingFieldset
                                  [form]="form"
                                  [open]="fieldsetState.bookingFieldset"
                                  [chipsToUpper]="chipsToUpper"></booking-fieldset>

                <traveller-fieldset [form]="form"
                                    [open]="fieldsetState.travellerFieldset"
                                    [chipsToUpper]="chipsToUpper"></traveller-fieldset>

                <document-fieldset [form]="form"
                                   [open]="fieldsetState.documentFieldset"
                                   [chipsToUpper]="chipsToUpper"></document-fieldset>

                <pricing-fieldset [form]="form"
                                  [open]="fieldsetState.pricingFieldset"
                                  [chipsToUpper]="chipsToUpper"></pricing-fieldset>

                <service-fieldset [form]="form"
                                  [open]="fieldsetState.serviceFieldset"
                                  [chipsToUpper]="chipsToUpper"></service-fieldset>

                <remark-fieldset [form]="form"
                                 [open]="fieldsetState.remarkFieldset"
                                 [chipsToUpper]="chipsToUpper">
                </remark-fieldset>
            </div>

            <div class="flex-1">
                <journey-fieldset #journeyFieldset
                                  [form]="form"
                                  [open]="fieldsetState.journeyFieldset"
                                  [chipsToUpper]="chipsToUpper"></journey-fieldset>

                <flight-fieldset [form]="form"
                                 [open]="fieldsetState.flightFieldset"
                                 [chipsToUpper]="chipsToUpper"></flight-fieldset>

                <voucher-fieldset #voucherFieldset
                                  [form]="form"
                                  [open]="fieldsetState.voucherFieldset"
                                  [chipsToUpper]="chipsToUpper"></voucher-fieldset>

                <accomodation-fieldset #stayFieldset
                                       [form]="form"
                                       [open]="fieldsetState.stayFieldset"
                                       [chipsToUpper]="chipsToUpper"></accomodation-fieldset>
                <fare-optimisation-fieldset
                                       [form]="form"
                                       [open]="fieldsetState.fareOptimisationFieldset"
                                       [chipsToUpper]="chipsToUpper" *permissionIf="sashaPermissions.SASHA_BOOKING_AIR_FARE_OPTIMISATION_USE"></fare-optimisation-fieldset>
            </div>

        </div>
        <div>
            <quality-check-fieldset #qualityCheckFieldset
                                    *permissionIf="sashaPermissions.SASHA_QUALITY_CHECK_SHOW"
                                    [form]="form"
                                    [open]="fieldsetState.qualityCheckFieldset"></quality-check-fieldset>
        </div>

        <afidium-service-fieldset [form]="form"
                                  [open]="fieldsetState.afidiumServiceFieldset"></afidium-service-fieldset>
    </div>
</card-form>
